import gql from "graphql-tag";

export const MY_HR_GET_CHANGE_REQUESTS_ATTACHEMENT = gql`
  query listAttachementByEmployee($employeeCode: String!, $type: String) {
    listAttachementByEmployee(employeeCode: $employeeCode, type: $type) {
      _id
      filename
      createdAt
    }
  }
`;
